import config from '@/config';

export const BASE_URL = config.resources_url;
export const FRONTEND_URL = config.frontend_url || '';
const currentHostname = typeof window === 'undefined' ? '' : window.location.hostname;
export const IS_LOCAL_ENVIRONMENT =
	import.meta.env.DEV ||
	FRONTEND_URL.includes('localhost') ||
	['localhost', '127.0.0.1', '::1'].includes(currentHostname);
export const IS_STAGING_ENVIRONMENT = config.environment === 'staging';
export const USE_DUMMY_GAME_DATA = config.use_dummy_game_data;
